/**
 * /auth/status hook — Batch 21a-3 §7.8.
 *
 * Available on both admin and app hosts. Role-only impersonation attribution.
 * Polls every 30s + refetches on window focus so the banner reflects server
 * truth promptly after a "Stop impersonating" action.
 */
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

interface AuthStatusUser {
  id: string;
  email: string;
  role: "admin" | "recruiter" | "interviewer" | "viewer" | "owner" | "member";
  is_super_admin: boolean;
}

interface AuthStatusResponse {
  is_authenticated: boolean;
  user: AuthStatusUser | null;
  is_impersonating: boolean;
  impersonation_role_attribution: "support_staff" | null;
}

export function useAuthStatus() {
  return useQuery<AuthStatusResponse, ApiError>({
    queryKey: ["auth", "status"],
    queryFn: async () => {
      const r = await apiClient.get<AuthStatusResponse>("/auth/status");
      return r.data;
    },
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    staleTime: 10_000,
  });
}
